export default {
    SET_IMAGES_RESULT(state, data) {
        state.imagesResult = data;
    },
    SET_ContentCategory_RESULT(state, data) {
        state.contentCategory = data;
    },
    SET_ContentByCategoryRef_RESULT(state, data) {
        state.contentByCategoryRef = data;
    },
    SET_ContentListByCategoryRef_RESULT(state, data) {
        state.contentListByCategoryRef = data;
    },

    SET_ContentListByCategoryFAQ_RESULT(state, data) {
        state.contentListByCategoryFAQ = data;
    },
    SET_ContentListByCategoryComments_RESULT(state, data) {
        state.contentListByCategoryComments = data;
    },
     SET_ContentListByCategoryArticles_RESULT(state, data) {
        state.contentListByCategoryArticles = data;
    },

}